export default __webpack_public_path__ + "static/media/reminder.fa683010.svg";